export const EmployeeSuccessMessage = {
  CREATED: "Employee created successfully",
  UPDATED: "Employee updated successfully",
  DELETED: "Employee deleted successfully",
  TAB_ACCESS: "Tab Access Updated Successfully",
  TERMINATED: "Employee terminated successfully",
  INFO_UPDATED: "Info Updated Successfully",
  DECLARATION_UPDATED: "Declaration Updated Successfully",
  NO_CHANGES: "Please make some changes",
  OTP_VERIFIED: "OTP verified successfully.",
  TABLE_UPDATED: "Employee Data Updated Successfully",
  BASIC_UPDATE: "Employee Basic Info Updated.",
  IMP_INFO_UPDATED: "Employee Important Information Updated Successfully.",
};

export const EMP_CONSTS = {
  TITLES: {
    DOCUMENT_UPLOAD: "Document Checklist & Upload",
    COVID: "Are You Fully Vaccinated For COVID-19",
  },
  INFO: {
    HEALTH:
      "Do you have any previous or current medical condition or restriction, physical or otherwise, which may affect your ability to perform the essential requirements of the job.",
    WORK_COMPENSATION:
      "This must include any medical condition or restriction arising from a previous workers compensation claim. Failer to provide such information may jeopardise your rights to workers compensation if a pre-existing disability is aggravated at work (section 79 of the workers compensation and injury management act 1981).",
    CRIMINAL_CONVICTIONS:
      " Do you have any current convictions for any offences from any court, or are you currently the subject of any charge pending before any court?.",
    PRIVACY:
      "Your application form contains personal information, which will be dealt with in accordance with our Privacy Policy. If you are successful in your application your form will become an employment record. If you are unsuccessful your application form will be destroyed.",
    AGREE_TERMS:
      "Company reserve its right to keep surveillance in workplace locations, vehicles and computer devices and biometrics to provide access to locations, etc..",
    DECLARE_INFO:
      "I, hereby declare that the information contained in this application is to the best of my knowledge true and correct.",
  },
};

export const EmployeeErrorMessage = {
  GLOBAL_ERROR: "Something went wrong",
};

export const OptionToast = {
  ADDED: "Option Added Successfully",
  NAME_REQUIRED: "Option Name is Required",
  DELETED: "Option Deleted Successfully",
};

export const EmploymentTypeList = [
  {
    label: "Full Time",
    value: "FULLTIME",
  },
  {
    label: "Part Time",
    value: "PARTTIME",
  },
  {
    label: "Casual",
    value: "CASUAL",
  },
];

export const EmployeeTabList = {
  ACTIVE: "ACTIVE",
  AWAITING: "AWAITING",
  DEACTIVATED: "DEACTIVATED",
  TERMINATED: "TERMINATED",
  EMPLOYEE_DEVICE: "DEVICE",
  WEIGH_SCALE_DEVICE: "weighscale-device",
};

export const Evaluation = [
  "UNSATISFACTORY",
  "FAIR",
  "SATISFACTORY",
  "GOOD",
  "EXCELLENT",
];

export const terminationReasons = [
  { label: "Resignation", value: "Resignation" },
  {
    label: "Involuntary Termination",
    value: "Involuntary_Termination",
  },
  {
    label: "Indefinite Layoff",
    value: "Indefinite_Layoff",
  },
  {
    label: "Reduction-in-Force",
    value: "Reduction_In_Force",
  },
  {
    label: "Contract Expiration",
    value: "Contract_Expiration",
  },
  { label: "Other", value: "Other" },
];

export const rehireRecommendation = [
  "Without Reservation",
  "With Reservation",
  "Would not recommend",
];

export const RehireRecommendation = {
  Without_Reservation: "Without Reservation",
  With_Reservation: "With Reservation",
  Would_not_recommend: "Would not recommend",
};

export const evaluationFields = {
  Attendance: "attendance",
  Cooperation: "cooperation",
  Initiative: "initiative",
  "Job Knowledge": "jobKnowledge",
  "Work Quality": "workQuality",
} as const;

export type EvaluationField = keyof typeof evaluationFields;
